import React, { PropsWithChildren } from 'react'
import { YaTrackerImpression } from '@yanolja-rnd/ya-tracker/index.react'

interface ImpressionProps {
  onImpressed?: () => void
  /* options */
  root?: Element | null
  rootMargin?: string
  threshold?: number | number[]
  disabled?: boolean
}
const Impression = (props: PropsWithChildren<ImpressionProps>) => {
  return <YaTrackerImpression {...props}>{props.children}</YaTrackerImpression>
}

export default Impression
